import * as z from 'zod';
import { ACCESS_KEY_TYPE } from 'src/features/accessKey/utils/types';

export type AccessKeyFormSchemaValues = z.infer<typeof accessKeyFormSchema>;
export const accessKeyFormSchema = z.object({
    type: z.enum(ACCESS_KEY_TYPE),
    value: z.string().min(1),
    valid_from: z.string().nullish(),
    valid_to: z.string().nullish(),
    pass_back_allowed: z.boolean().nullish(),
});